/**
 * ShareIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ShareIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18 22.185q-1.327 0-2.257-.929A3.07 3.07 0 0 1 14.815 19q0-.18.025-.374.024-.194.075-.356l-6.757-3.932a3.4 3.4 0 0 1-.997.623q-.554.225-1.161.224-1.328 0-2.256-.929A3.07 3.07 0 0 1 2.814 12q0-1.327.93-2.257A3.07 3.07 0 0 1 6 8.815q.607 0 1.16.224.555.225.998.624l6.757-3.933a2 2 0 0 1-.075-.356A3 3 0 0 1 14.815 5q0-1.327.929-2.256A3.07 3.07 0 0 1 18 1.814q1.328 0 2.256.93.93.93.93 2.256 0 1.327-.93 2.257A3.08 3.08 0 0 1 18 8.185a3.1 3.1 0 0 1-1.16-.218 3.3 3.3 0 0 1-.998-.618L9.085 11.27q.051.162.075.356a3 3 0 0 1 0 .748q-.024.195-.075.356l6.757 3.92c.293-.264.63-.473.997-.617A3.1 3.1 0 0 1 18 15.815q1.328 0 2.256.929.93.93.93 2.256a3.07 3.07 0 0 1-.93 2.256q-.93.93-2.256.93M18 6q.424 0 .712-.287A.97.97 0 0 0 19 5a.97.97 0 0 0-.288-.712A.97.97 0 0 0 18 4a.97.97 0 0 0-.712.288A.97.97 0 0 0 17 5q0 .424.288.713A.97.97 0 0 0 18 6M6 13q.424 0 .713-.287A.97.97 0 0 0 7 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 6 11a.97.97 0 0 0-.712.287A.97.97 0 0 0 5 12q0 .424.288.713A.97.97 0 0 0 6 13m12 7q.424 0 .712-.288A.97.97 0 0 0 19 19a.97.97 0 0 0-.288-.712A.97.97 0 0 0 18 18a.97.97 0 0 0-.712.288A.97.97 0 0 0 17 19q0 .424.288.712A.97.97 0 0 0 18 20" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ShareIcon = makeIcon('ShareIcon', ShareIconSvg)
